import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { MainService } from '../../Services/service.service';
import { SearchRouteService } from '../../Services/searchroute.service';
import { filter, mergeMap, map } from 'rxjs/operators';
import { Categories } from "../../Services/searchroute.service";
import { SubRegion } from '../../api/WickedApiClient';
import { DomSanitizer } from '@angular/platform-browser';

declare const MOSTPOPULARCITIES60: SubRegion[];

@Component({
  selector: 'app-seo-texts-wrapper',
  templateUrl: './seo-texts-wrapper.component.html',
  styleUrls: ['./seo-texts-wrapper.component.scss']
})
export class SeoTextsWrapperComponent implements OnInit {

  public currentItem: string;

  seoUrlMap = window["seoUrlMap"];
  seoWrapper = document.getElementById("staticSeoText");
  currentUrl: string = "";
  curentCategoryId: number = 0;
  casualDating: boolean = false;
  currentCityId: number = 0;

  constructor(private route: Router, public service: MainService, private searchRouteService: SearchRouteService, private activatedRoute: ActivatedRoute, private _sanitizer: DomSanitizer) {
    this.route.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.currentUrl = event.url;
        this.setSEOView(this.currentUrl);
        //this.seoWrapper.style.display = "none";
        if (this.seoWrapper) {
          this.seoWrapper.remove();
        }

      }
    });

    // this.service.advService.resultListUpdate.subscribe(r => {
    //   console.log("result list update");
    //   this.setSEOView(this.currentUrl);

    //   seoWrapper.remove();
    // });

  }

  ngOnInit() {
  }

  setSEOView(curentUrl: string) {
    const slicedUrl = curentUrl.slice(1);
    if (this.seoUrlMap) {
      if (this.currentUrl == "/") {
        this.currentItem = this.seoUrlMap.texts[1].text;
        //this.seoWrapper.innerHTML = this.seoUrlMap.texts[1].text;
      }
      else if (this.seoUrlMap.urls[slicedUrl]) {
        const seoTextId = this.seoUrlMap.urls[slicedUrl];
        this.currentItem = this.seoUrlMap.texts[seoTextId].text;
        //this.seoWrapper.innerHTML = this.seoUrlMap.texts[seoTextId].text;
      } else {
        this.currentItem = "";
      }
    }
  }

}
